// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3hKCp","errorLogs":"EditorFooter_errorLogs__1MPb5"};